module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAACuBAMAAAB+XC0hAAAAGFBMVEX/AAD////Kysr/+/v/Ghr/Bwf/yMj/xMQtVrexAAAA1ElEQVR42u3aMQrCQBCG0UX0AEsgteQGwcLWwgN4hZzB+4PgVhZmYSAwIe/rh339/mVKWbmWeOeh/m1+lHgnLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLKxDsJ691ljd4yjrtdQNGy9R1vvWqa7Uu72HWctcN2sYsbC+YWFhYWFhYbWwsLCwsLCwWlhYWFhYWFgtLCwsLCysQ7OyfqH/vJNlcJB0npF1zIKFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFtSfWlLIPBt4CXP1cmPEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/flag_rect_big/8.png
// module id = 9eda
// module chunks = 1